<template>
	<div class="text-justify">
		<app-overlay-loader v-if="preloader" />
		<div class="row">
			<!-- Info Form -->
			<div v-if="showBasicInfo" class="col-lg-12 padding-x-40">
				<form
					ref="basicInfoForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- First Name -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_first_name"
											>First Name</label
										>
										<input
											id="input_first_name"
											type="text"
											placeholder="First Name"
											v-model="basicInfoForm.first_name"
											name="first_name"
											class="form-control"
										/>
									</div>
								</div>
								<!-- Nickname -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_nickname"
											>Nickname</label
										>
										<input
											id="input_nickname"
											type="text"
											placeholder="Nickname"
											v-model="basicInfoForm.nickname"
											name="nickname"
											class="form-control"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Last Name -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_last_name"
											>Last Name</label
										>
										<input
											id="input_last_name"
											type="text"
											placeholder="Last Name"
											v-model="basicInfoForm.last_name"
											name="last_name"
											class="form-control"
										/>
									</div>
								</div>
								<!-- Chinese Name -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_chinese_name"
											>Chinese Name</label
										>
										<input
											id="input_chinese_name"
											type="text"
											placeholder="Chinese Name"
											v-model="basicInfoForm.chinese_name"
											name="chinese_name"
											class="form-control"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Place of Birth -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_place_of_birth"
											>Place of Birth</label
										>
										<app-input
											id="input_place_of_birth"
											type="text"
											v-model="
												basicInfoForm.place_of_birth
											"
											placeholder="Place of Birth"
											:required="true"
										/>
									</div>
								</div>
								<!-- Date of Birth -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_date_of_birth"
											>Date of Birth</label
										>
										<app-input
											id="input_date_of_birth"
											type="date"
											v-model="
												basicInfoForm.date_of_birth
											"
											placeholder="Date of Birth"
										/>
									</div>
								</div>
								<!-- Gender -->
								<div class="col-lg-4">
									<div class="form-group">
										<label for="input_gender">Gender</label>
										<app-input
											id="input_gender"
											type="radio"
											:list="gender_list"
											v-model="basicInfoForm.gender"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitBasicInfoFormDisabled"
							@click.prevent="submitInfoForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="submit"
							class="btn btn-secondary"
							@click.prevent="clearInfoForm"
						>
							{{ $t("clear") }}
						</button> -->
					</div>
				</form>
			</div>
			<!-- School History Table -->
			<div v-if="showSchoolHistory" class="col-lg-12 mt-8">
				<student-profile-tab-school-school-history-table
					:value="value"
				/>
			</div>
			<!-- School Form -->
			<div v-if="showSchoolHistory" class="col-lg-12 mt-8 padding-x-40">
				<form
					ref="schoolForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<!-- Plan to move to another school in 3 years radio button -->
						<div class="col-lg-12">
							<div class="form-group row">
								<label
									for="radio_is_plan_move_school"
									class="col-lg-3"
								>
									Plan to move to another school in 3 years:
								</label>
								<div class="col-lg-9">
									<app-input
										id="radio_is_plan_move_school"
										type="radio"
										:list="yes_and_no_list"
										v-model="schoolForm.is_plan_move_school"
									/>
								</div>
							</div>
						</div>

						<!-- Form if plan to move to another school in 3 years is yes -->
						<div
							class="col-lg-12"
							v-if="schoolForm.is_plan_move_school == 1"
						>
							<div class="row">
								<!-- Next School Name -->
								<div class="col-md-4">
									<div class="form-group">
										<label for="input_pms"
											>Next School Name</label
										>
										<app-input
											type="advance-search-select"
											:loaded-per-time="10"
											v-model="input_pms"
											@input="setPlanMoveSchool"
											fetch-url="master/school"
											placeholder="School"
											list-value-field="name"
											required
										/>
									</div>
								</div>
								<!-- School Level -->
								<div class="col-md-4">
									<div class="form-group">
										<label for="input_pmsl">
											School Level
										</label>
										<app-input
											type="advance-search-select"
											:loaded-per-time="10"
											v-model="input_pmsl"
											@input="setPlanMoveSchoolLevel"
											fetch-url="master/school-level"
											placeholder="School Level"
											list-value-field="name"
											required
										/>
									</div>
								</div>
								<!-- Have Chinese Lesson at School -->
								<div class="col-md-4">
									<div class="form-group">
										<label
											for="input_plan_move_chinese_basic"
											>Have Chinese Lesson at
											School</label
										>
										<app-input
											id="input_plan_move_chinese_basic"
											type="radio"
											:list="yes_and_no_list"
											v-model="
												schoolForm.plan_move_chinese_basic
											"
										/>
									</div>
								</div>
							</div>
						</div>

						<!-- Interested to study abroad radio button -->
						<div class="col-lg-12">
							<div class="form-group row">
								<label
									for="radio_is_interested_travel"
									class="col-lg-3"
								>
									Interested to study abroad:
								</label>
								<div class="col-lg-9">
									<app-input
										id="radio_is_interested_travel"
										type="radio"
										:list="yes_and_no_list"
										v-model="
											schoolForm.is_interested_travel
										"
									/>
								</div>
							</div>
						</div>

						<!-- Form if interested to study abroad is yes -->
						<div
							class="col-lg-12"
							v-if="schoolForm.is_interested_travel == 1"
						>
							<!-- Country or City of Destination -->
							<div class="form-group row align-items-center">
								<label
									class="col-md-2 mb-md-0"
									for="input_interested_countries"
								>
									Country or City of Destination
								</label>
								<app-input
									id="input_interested_countries"
									class="col-md-8"
									type="multi-select"
									:list="countryOrCityLists"
									:isAnimatedDropdown="true"
									v-model="schoolForm.interested_countries"
									placeholder="Country or City"
								/>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 ml-4 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								:disabled="submitSchoolFormDisabled"
								@click.prevent="submitSchoolForm"
							>
								{{ $t("submit") }}
							</button>
							<!-- <button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clearSchoolForm"
							>
								{{ $t("clear") }}
							</button> -->
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { BasicInfoFormMixin } from "./BasicInfoFormMixin.js";
import { SchoolFormMixin } from "./SchoolFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "StudentTabInfo",
	mixins: [BasicInfoFormMixin, SchoolFormMixin, GlobalHelperMixin],
	props: {
		showBasicInfo: {
			type: Boolean,
			default: true,
		},
		showSchoolHistory: {
			type: Boolean,
			default: true,
		},
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitBasicInfoFormDisabled: true,
			originalBasicInfoForm: {},
			submitSchoolFormDisabled: true,
			originalSchoolForm: {},
			basicInfoForm: {
				first_name: this.value.name,
				nickname: this.value.nick_name,
				last_name: this.value.surname,
				chinese_name: this.value.chinese_name,
				place_of_birth: this.value.place_of_birth_name,
				date_of_birth: this.value.date_of_birth,
				gender: this.value.gender,
			},
			schoolForm: {
				is_plan_move_school: this.value.is_plan_move_school ?? 0,
				plan_move_school: this.value.plan_move_school,
				plan_move_school_level: this.value.plan_move_school_level,
				plan_move_chinese_basic:
					this.value.plan_move_chinese_basic ?? 0,
				is_interested_travel: this.value.is_interested_travel ?? 0,
				interested_countries: this.value.interested_countries,
			},
			countryOrCityLists: [],
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
			gender_list: [
				{ id: 1, value: "Male" },
				{ id: 2, value: "Female" },
			],
			input_place_of_birth: this.value
				? this.value.place_of_birth_full
					? {
							id: this.value.place_of_birth_full.id || 0,
							name: this.value.place_of_birth_full.name || "",
							code: this.value.place_of_birth_full.code,
							is_active: this.value.place_of_birth_full.is_active,
					  }
					: {
							id: this.value.place_of_birth_full?.id || 0,
							name: this.value.place_of_birth_full?.name || "",
							code: this.value.place_of_birth_full?.code,
							is_active:
								this.value.place_of_birth_full?.is_active,
					  }
				: {
						id: this.value.place_of_birth_full.id || 0,
						name: this.value.place_of_birth_full.name || "",
						code: this.valu.place_of_birthe.code,
						is_active: this.value.place_of_birth_full.is_active,
				  },
			input_pms: this.value
				? this.value.plan_move_school
					? {
							id: this.value.plan_move_school.id || 0,
							name: this.value.plan_move_school.name || "",
							code: this.value.plan_move_school.code,
							is_active: this.value.plan_move_school.is_active,
					  }
					: {
							id: this.value.plan_move_school?.id || 0,
							name: this.value.plan_move_school?.name || "",
							code: this.value.plan_move_school?.code,
							is_active: this.value.plan_move_school?.is_active,
					  }
				: {
						id: this.value.plan_move_school.id || 0,
						name: this.value.plan_move_school.name || "",
						code: this.value.plan_move_school.code,
						is_active: this.value.plan_move_school.is_active,
				  },
			input_pmsl: this.value
				? this.value.plan_move_school_level
					? {
							id: this.value.plan_move_school_level.id || 0,
							name: this.value.plan_move_school_level.name || "",
							code: this.value.plan_move_school_level.code,
							is_active:
								this.value.plan_move_school_level.is_active,
					  }
					: {
							id: this.value.plan_move_school_level?.id || 0,
							name: this.value.plan_move_school_level?.name || "",
							code: this.value.plan_move_school_level?.code,
							is_active:
								this.value.plan_move_school_level?.is_active,
					  }
				: {
						id: this.value.plan_move_school_level.id || 0,
						name: this.value.plan_move_school_level.name || "",
						code: this.value.plan_move_school_level.code,
						is_active: this.value.plan_move_school_level.is_active,
				  },
		};
	},
	created() {
		this.fetchData();
		this.originalBasicInfoForm = JSON.parse(
			JSON.stringify(this.basicInfoForm)
		);
		this.originalSchoolForm = JSON.parse(JSON.stringify(this.schoolForm));
	},
	methods: {
		async fetchData() {
			try {
				let [countryResponse, cityResponse] = await Promise.all([
					axios.get("/master/country"),
					axios.get("/master/city?per_page=500"),
				]);

				countryResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});

				cityResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},

		// BASIC INFO FORM
		beforeSubmitBasicInfo() {
			this.preloader = true;
		},
		submitInfoForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition:
						this.basicInfoForm.gender == null ||
						isNaN(this.basicInfoForm.gender),
					requiredFields: ["gender"],
					errorMessage: "Please select {field}",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.basicInfoForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalBasicInfoForm = JSON.parse(
					JSON.stringify(this.basicInfoForm)
				);
				this.submitBasicInfoFormDisabled =
					JSON.stringify(this.basicInfoForm) ===
					JSON.stringify(this.originalBasicInfoForm);

				this.saveBasicInfo(this.basicInfoForm);
			}
		},
		afterSuccessBasicInfo(res) {
			this.$toastr.s(res.data.message);
			// this.clearInfoForm();
		},
		afterFinalResponseBasicInfo() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorBasicInfo(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearInfoForm() {
			// Clear form fields here
			this.basicInfoForm = {};
			// this.basicInfoForm.custom_file = null;
		},
		setPlaceOfBirth(data) {
			this.basicInfoForm.place_of_birth = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.basicInfoForm.place_of_birth = data.id;
			}
		},

		// SCHOOL FORM
		beforeSubmitSchoolForm() {
			this.preloader = true;
		},
		submitSchoolForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition: this.schoolForm.is_plan_move_school == 1,
					requiredFields: [
						"plan_move_school",
						"plan_move_school_level",
					],
					errorMessage:
						"Please select {field} if Plan to move to another school in 3 years is Yes",
				},
				{
					condition: this.schoolForm.is_interested_travel == 1,
					requiredFields: ["interested_countries"],
					errorMessage:
						"Please select Country or City of Destination if Interested to study abroad is Yes",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			// Special handling for plan_move_chinese_basic
			if (
				this.schoolForm.is_plan_move_school == 1 &&
				this.schoolForm.plan_move_chinese_basic === null
			) {
				this.schoolForm.plan_move_chinese_basic = 0; // Set a default value
			}

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.schoolForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalSchoolForm = JSON.parse(
					JSON.stringify(this.schoolForm)
				);
				this.submitSchoolFormDisabled =
					JSON.stringify(this.schoolForm) ===
					JSON.stringify(this.originalSchoolForm);

				this.saveSchoolForm(this.schoolForm);
			}
		},
		afterSuccessSchoolForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearInfoForm();
		},
		afterFinalResponseSchoolForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorSchoolForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearSchoolForm() {
			// Clear form fields here
			this.schoolForm = {};
			// this.schoolForm.custom_file = null;
		},

		setPlanMoveSchool(data) {
			this.schoolForm.plan_move_school = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.schoolForm.plan_move_school = data.id;
			}
		},
		resetPlanMoveSchool() {
			this.input_pms = {};
			this.schoolForm.plan_move_school = "";
		},
		setPlanMoveSchoolLevel(data) {
			this.schoolForm.plan_move_school_level = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.schoolForm.plan_move_school_level = data.id;
			}
		},
		resetPlanMoveSchoolLevel() {
			this.input_pmsl = {};
			this.schoolForm.plan_move_school_level = "";
		},
	},
	watch: {
		basicInfoForm: {
			handler: function (val) {
				if (val.date_of_birth) {
					val.date_of_birth = this.formatDate(val.date_of_birth);
				}
				val.gender = parseInt(val.gender);

				// Check if basicInfoForm has changed
				const isBasicInfoFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalBasicInfoForm);

				// Update the submitBasicInfoFormDisabled based on the change status
				this.submitBasicInfoFormDisabled = !isBasicInfoFormChanged;
			},
			deep: true,
		},
		schoolForm: {
			handler: function (val) {
				val.is_plan_move_school = parseInt(val.is_plan_move_school);
				val.plan_move_chinese_basic = parseInt(
					val.plan_move_chinese_basic
				);
				val.is_interested_travel = parseInt(val.is_interested_travel);

				// Check if schoolForm has changed
				const isSchoolFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalSchoolForm);

				// Update the submitSchoolFormDisabled based on the change status
				this.submitSchoolFormDisabled = !isSchoolFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
